// import axios from 'axios';
import axios from '../../utils/axiosConfig';
import {
  FETCH_TASKS_REQUEST,
  FETCH_TASKS_SUCCESS,
  FETCH_TASKS_FAIL,
  CREATE_TASK_REQUEST,
  CREATE_TASK_SUCCESS,
  CREATE_TASK_FAIL,
  FETCH_TASK_REQUEST,
  FETCH_TASK_SUCCESS,
  FETCH_TASK_FAIL,
  UPDATE_TASK_REQUEST,
  UPDATE_TASK_SUCCESS,
  UPDATE_TASK_FAIL,
  DELETE_TASK_REQUEST,
  DELETE_TASK_SUCCESS,
  DELETE_TASK_FAIL,
} from '../constants/taskConstants';

export const fetchTasks = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_TASKS_REQUEST });
    const { data } = await axios.get('/api/tasks');
    dispatch({ type: FETCH_TASKS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FETCH_TASKS_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const createTask = (task) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_TASK_REQUEST });
    const { data } = await axios.post('/api/tasks', task);
    dispatch({ type: CREATE_TASK_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: CREATE_TASK_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const fetchTask = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_TASK_REQUEST });
    const { data } = await axios.get(`/api/tasks/${id}`);
    dispatch({ type: FETCH_TASK_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FETCH_TASK_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const getTasksByCaseId = (caseId) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_TASKS_REQUEST });
    const res = await axios.get(`/api/tasks/case/${caseId}`);
    dispatch({ type: FETCH_TASKS_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: FETCH_TASKS_FAIL, payload: error.message });
  }
};

export const updateTask = (task) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_TASK_REQUEST });
    const { data } = await axios.put(`/api/tasks/${task._id}`, task);
    dispatch({ type: UPDATE_TASK_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: UPDATE_TASK_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const deleteTask = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_TASK_REQUEST });
    await axios.delete(`/api/tasks/${id}`);
    dispatch({ type: DELETE_TASK_SUCCESS, payload: id });
  } catch (error) {
    dispatch({
      type: DELETE_TASK_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};